import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ECU } from '../apiHandler/dtc-retrieval/dtc-retrieval.service';
import { InfoDataSet } from 'src/app/components/menu/menu/menu.component';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public machineNumber = new BehaviorSubject<any>({
    number: '',
    id: '',
    series: ''
  });

  public machineInfos = new BehaviorSubject<any>({
    line: '',
    name: '',
    engine: ''
  });

  public variables = new BehaviorSubject<any>({
    connected: false,
    attempt: false,
    error: false,
    message: ''
  });

  public user = new BehaviorSubject<any>({
    name: '',
    roles: []
  });
  
  public error = new BehaviorSubject<any>({
    occurred: false
  });

  public io = new BehaviorSubject<any>({
    expanded_id: '',
    dtc_ecu: 120
  });

  public sidenav = new BehaviorSubject<any>({
    pinned: false
  });

  public swVersion = new BehaviorSubject<any>({
    loaded: false,
    versions: []
  });

  private cancelPendingRequests$ = new Subject<void>()


  public cancelPendingRequests() {
    this.cancelPendingRequests$.next()
  }

  public onCancelPendingRequests() {
    return this.cancelPendingRequests$.asObservable()
  }

  // previousUrl
  private previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public previousUrl$: Observable<string> = this.previousUrl.asObservable();

  setPreviousUrl(previousUrl: string) {
    this.previousUrl.next(previousUrl);
  }

  // errorMessage for initial machine connection
  private errorMessage: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public errorMessage$: Observable<string> = this.errorMessage.asObservable();

  setErrorMessage(message: string) {
    this.errorMessage.next(message);
  }

  // idleTimer - last time user interaction
  private lastActivity: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public lastActivity$: Observable<number> = this.lastActivity.asObservable();

  setLastActivity() {
    this.lastActivity.next(Date.now());
  }

  public savedParameters = new BehaviorSubject<any>({
    locked: false,
    parameters: []
  });

  public comission = new BehaviorSubject<any>({
    enabled: false
  });

  public iOEcus: number[] = [];
  public dtcEcus: ECU[] = [];
  public menuInfoset!: InfoDataSet;
  public canToIoEcus: string[] = [];
  public canToDtcEcus: string[] = [];

  public ecuAssignment = this.machineInfos.subscribe(
    info => {
      switch(info.line) {
        case 'green':
          this.iOEcus = [120, 121, 122];

          this.dtcEcus = [
            {value: 120, viewValue: "Master (120)", notAnOption: false},
            {value: 0, viewValue: "Engine (0)", notAnOption: false},
            {value: 121, viewValue: "Slave (121)", notAnOption: false},
            {value: 122, viewValue: "Kabinensteuergerät (122)", notAnOption: false},
            //{value: 188, viewValue: "Telemetriemodul (188)", notAnOption: true},
          ];

          this.menuInfoset = {
            dataPoints: [
              /*{dataName: { name: 'Ignition'}},*/ // 362
              {dataName: { name: 'SafetyLever'}, type: 'b', trans: 'MENU.SECURITY', goodState: 1}, // 363
              {dataName: { name: 'EngineRunning'}, type: 'b', trans: 'MENU.ENGINE', goodState: 1}, // 365
              {dataName: { name: 'EmergencyStop'}, type: 'b', trans: 'MENU.EMERGENCY', goodState: 1}, // 364
              {dataName: { name: 'MachineEngineRunningTime'}, type: 'nb', trans: 'MENU.TIME'}, // 258
              {dataName: { name: 'AlternatorVoltage'}, type: 'nb', trans: 'MENU.VOLTAGE'} // 366
            ]
          }

          this.canToIoEcus = ['Master ECU OBW', 'Slave ECU OBW', 'Slave ECU Kabine'];
          this.canToDtcEcus = ['Master ECU OBW', 'Slave ECU OBW', 'Slave ECU Kabine', 'Motor'];
          break;
        case 'multi':
          this.iOEcus = [120,121];

          this.dtcEcus = [
            {value: 120, viewValue: "Master (120)", notAnOption: false},
            {value: 0, viewValue: "Engine (0)", notAnOption: false},
            {value: 121, viewValue: "Slave (121)", notAnOption: false},
          ];

          this.menuInfoset = {
            dataPoints: [
              {dataName: { name: 'ReleaseOperatorPresent'}, type: 'b', trans: 'MENU.RELEASEOPERATER', goodState: 1}, // noch einzufügen !!!!
              {dataName: { name: 'EngineRunning'}, type: 'b', trans: 'MENU.ENGINE', goodState: 1}, // 365
              {dataName: { name: 'EmergencyStop'}, type: 'b', trans: 'MENU.EMERGENCY', goodState: 0}, // 364
              {dataName: { name: 'MachineEngineRunningTime'}, type: 'nb', trans: 'MENU.TIME'}, // 258
              {dataName: { name: 'AlternatorVoltage'}, type: 'nb', trans: 'MENU.VOLTAGE'} // 366
            ]
          }

          this.canToIoEcus = ['Master ECU', 'Slave ECU'];
          this.canToDtcEcus = ['Master ECU', 'Slave ECU Drive', 'Engine ECU'];
          break;
        default: //currently multi for testing (local: crane)
          this.iOEcus = [120, 121];

          this.dtcEcus = [
            {value: 120, viewValue: "Master (120)", notAnOption: false},
            {value: 0, viewValue: "Engine (0)", notAnOption: false},
            {value: 121, viewValue: "Slave (121)", notAnOption: false},
          ];

          this.menuInfoset = {
            dataPoints: [
              {dataName: { name: 'ReleaseOperatorPresent'}, type: 'b', trans: 'MENU.RELEASEOPERATER', goodState: 1}, // 363
              {dataName: { name: 'EngineRunning'}, type: 'b', trans: 'MENU.ENGINE', goodState: 1}, // 365
              {dataName: { name: 'EmergencyStop'}, type: 'b', trans: 'MENU.EMERGENCY', goodState: 0}, // 364
              {dataName: { name: 'MachineEngineRunningTime'}, type: 'nb', trans: 'MENU.TIME'}, // 258
              {dataName: { name: 'AlternatorVoltage'}, type: 'nb', trans: 'MENU.VOLTAGE'} // 366
            ]
          }

          this.canToIoEcus = ['Master ECU', 'Slave ECU'];
          this.canToDtcEcus = ['Master ECU', 'Slave ECU Drive', 'Engine ECU'];
      }
    }
  )
  
  
    
}


export const _baseUrl = environment.PROTOCOL + environment.HOST + ':' + environment.PORT.toString() + '/api/v2/';
export const _baseUrl_v1 = environment.PROTOCOL + environment.HOST + ':' + environment.PORT.toString();

export const _sentrackBaseUrl = "https://sentrack.sennebogen.com/api";

export const _sebo_subdomain = "https://func-endofline-cloudinterface-prod.sennebogen.com"